module.exports = __webpack_public_path__ + "img/AT0000018318285.06d4d6d2.png";